import React, { useState } from 'react';
import { SearchIcon, DownloadIcon, RefreshCwIcon } from 'lucide-react';
interface ActivityLog {
  id: string;
  timestamp: string;
  user: {
    id: string;
    name: string;
    email: string;
    role: string;
  };
  action: string;
  section: string;
  description: string;
  objectId: string;
  details: {
    amount?: string;
  };
  ipAddress: string;
  userAgent: string;
}
export function ActivityLogs() {
  const [activityLogs] = useState<ActivityLog[]>(() => {
    const logs: ActivityLog[] = [];
    const now = new Date();
    const actions = [{
      type: 'created',
      section: 'Payments',
      desc: 'Payment created'
    }, {
      type: 'updated',
      section: 'Payments',
      desc: 'Payment updated'
    }, {
      type: 'deleted',
      section: 'Payments',
      desc: 'Payment deleted'
    }, {
      type: 'created',
      section: 'Customers',
      desc: 'Customer created'
    }, {
      type: 'updated',
      section: 'Customers',
      desc: 'Customer updated'
    }, {
      type: 'deleted',
      section: 'Customers',
      desc: 'Customer deleted'
    }, {
      type: 'created',
      section: 'Invoices',
      desc: 'Invoice created'
    }, {
      type: 'updated',
      section: 'Invoices',
      desc: 'Invoice updated'
    }, {
      type: 'approved',
      section: 'Bills',
      desc: 'Bill approved'
    }, {
      type: 'created',
      section: 'Refunds',
      desc: 'Refund created'
    }, {
      type: 'updated',
      section: 'Settings',
      desc: 'Settings updated'
    }, {
      type: 'created',
      section: 'Users',
      desc: 'User invited'
    }, {
      type: 'updated',
      section: 'Security',
      desc: 'Security settings updated'
    }];
    const realUsers = [{
      id: '1',
      name: 'Simon Lee',
      email: 'ahmed@bilabilamart.mv',
      role: 'Owner'
    }, {
      id: '2',
      name: 'Sarah Tan',
      email: 'aishath@bilabilamart.mv',
      role: 'Finance'
    }, {
      id: '3',
      name: 'Ahmad Rahman',
      email: 'ibrahim@bilabilamart.mv',
      role: 'Operations'
    }];
    for (let i = 0; i < 80; i++) {
      const action = actions[Math.floor(Math.random() * actions.length)];
      const user = realUsers[Math.floor(Math.random() * realUsers.length)];
      const minutesAgo = Math.floor(Math.random() * 43200);
      const timestamp = new Date(now.getTime() - minutesAgo * 60000);
      logs.push({
        id: `log-${i + 1}`,
        timestamp: timestamp.toISOString(),
        user: {
          id: user.id,
          name: user.name,
          email: user.email,
          role: user.role
        },
        action: action.type,
        section: action.section,
        description: action.desc,
        objectId: `${action.section.toLowerCase()}_${Math.random().toString(36).substr(2, 9)}`,
        details: {
          amount: Math.random() > 0.5 ? `MVR ${(Math.random() * 1000).toFixed(2)}` : undefined
        },
        ipAddress: `${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}`,
        userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36'
      });
    }
    return logs.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
  });
  const [logFilters, setLogFilters] = useState({
    search: '',
    dateRange: '7days',
    user: 'all',
    section: 'all'
  });
  const [logsPerPage, setLogsPerPage] = useState(25);
  const [currentLogPage, setCurrentLogPage] = useState(1);
  const users = [{
    id: '1',
    name: 'Simon Lee'
  }, {
    id: '2',
    name: 'Sarah Tan'
  }, {
    id: '3',
    name: 'Ahmad Rahman'
  }];
  const filteredLogs = activityLogs.filter(log => {
    if (logFilters.search && !log.description.toLowerCase().includes(logFilters.search.toLowerCase()) && !log.user.name.toLowerCase().includes(logFilters.search.toLowerCase())) return false;
    if (logFilters.user !== 'all' && log.user.id !== logFilters.user) return false;
    if (logFilters.section !== 'all' && log.section !== logFilters.section) return false;
    if (logFilters.dateRange !== 'all') {
      const logDate = new Date(log.timestamp);
      const now = new Date();
      const daysDiff = Math.floor((now.getTime() - logDate.getTime()) / (1000 * 60 * 60 * 24));
      if (logFilters.dateRange === '24h' && daysDiff > 1) return false;
      if (logFilters.dateRange === '7days' && daysDiff > 7) return false;
      if (logFilters.dateRange === '30days' && daysDiff > 30) return false;
    }
    return true;
  });
  const totalPages = Math.ceil(filteredLogs.length / logsPerPage);
  const paginatedLogs = filteredLogs.slice((currentLogPage - 1) * logsPerPage, currentLogPage * logsPerPage);
  const getRelativeTime = (timestamp: string) => {
    const now = new Date();
    const then = new Date(timestamp);
    const seconds = Math.floor((now.getTime() - then.getTime()) / 1000);
    if (seconds < 60) return `${seconds}s ago`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    return `${days}d ago`;
  };
  return <div className="max-w-7xl mx-auto py-8 px-4" data-id="element-13504">
      <div className="mb-8" data-id="element-13505">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-13506">Activity Logs</h1>
        <p className="text-gray-600" data-id="element-13507">
          View and track all user activities and system events
        </p>
      </div>

      <div className="space-y-6" data-id="element-13508">
        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-13509">
          <div className="bg-gray-50 px-6 py-4 border-b border-gray-200" data-id="element-13510">
            <h3 className="text-md font-semibold text-gray-900 flex items-center gap-2" data-id="element-13511">
              <SearchIcon size={18} className="text-gray-600" data-id="element-13512" />
              Filters
            </h3>
          </div>
          <div className="p-6 space-y-4" data-id="element-13513">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-13514">
              <div data-id="element-13515">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-13516">
                  Search
                </label>
                <input type="text" placeholder="Search logs..." className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#E2231A] focus:border-transparent text-sm" value={logFilters.search} onChange={e => setLogFilters({
                ...logFilters,
                search: e.target.value
              })} data-id="element-13517" />
              </div>
              <div data-id="element-13518">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-13519">
                  Date Range
                </label>
                <select className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#EB4A42] focus:border-transparent text-sm" value={logFilters.dateRange} onChange={e => setLogFilters({
                ...logFilters,
                dateRange: e.target.value
              })} data-id="element-13520">
                  <option value="all" data-id="element-13521">All Time</option>
                  <option value="24h" data-id="element-13522">Last 24 Hours</option>
                  <option value="7days" data-id="element-13523">Last 7 Days</option>
                  <option value="30days" data-id="element-13524">Last 30 Days</option>
                </select>
              </div>
              <div data-id="element-13525">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-13526">
                  User
                </label>
                <select className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#EB4A42] focus:border-transparent text-sm" value={logFilters.user} onChange={e => setLogFilters({
                ...logFilters,
                user: e.target.value
              })} data-id="element-13527">
                  <option value="all" data-id="element-13528">All Users</option>
                  {users.map(u => <option key={u.id} value={u.id} data-id="element-13529">
                      {u.name}
                    </option>)}
                </select>
              </div>
              <div data-id="element-13530">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-13531">
                  Section
                </label>
                <select className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#EB4A42] focus:border-transparent text-sm" value={logFilters.section} onChange={e => setLogFilters({
                ...logFilters,
                section: e.target.value
              })} data-id="element-13532">
                  <option value="all" data-id="element-13533">All Sections</option>
                  <option value="Payments" data-id="element-13534">Payments</option>
                  <option value="Customers" data-id="element-13535">Customers</option>
                  <option value="Invoices" data-id="element-13536">Invoices</option>
                  <option value="Bills" data-id="element-13537">Bills</option>
                  <option value="Refunds" data-id="element-13538">Refunds</option>
                  <option value="Users" data-id="element-13539">Users</option>
                  <option value="Settings" data-id="element-13540">Settings</option>
                  <option value="Security" data-id="element-13541">Security</option>
                </select>
              </div>
              <div data-id="element-13542">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-13543">
                  Per Page
                </label>
                <select className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#EB4A42] focus:border-transparent text-sm" value={logsPerPage} onChange={e => {
                setLogsPerPage(Number(e.target.value));
                setCurrentLogPage(1);
              }} data-id="element-13544">
                  <option value="25" data-id="element-13545">25</option>
                  <option value="50" data-id="element-13546">50</option>
                  <option value="100" data-id="element-13547">100</option>
                </select>
              </div>
            </div>
            <div className="flex items-center justify-between pt-2" data-id="element-13548">
              <p className="text-sm text-gray-600" data-id="element-13549">
                Showing {paginatedLogs.length} of {filteredLogs.length} logs
              </p>
              <div className="flex gap-2" data-id="element-13550">
                <button className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors flex items-center gap-1" data-id="element-13551">
                  <RefreshCwIcon size={14} data-id="element-13552" />
                  Refresh
                </button>
                <button className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors flex items-center gap-1" data-id="element-13553">
                  <DownloadIcon size={14} data-id="element-13554" />
                  Export
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-13555">
          <div className="overflow-x-auto" data-id="element-13556">
            <table className="w-full" data-id="element-13557">
              <thead className="bg-gray-50 border-b border-gray-200" data-id="element-13558">
                <tr data-id="element-13559">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-13560">
                    Timestamp
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-13561">
                    User
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-13562">
                    Action
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-13563">
                    Section
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-13564">
                    Object ID
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-13565">
                    IP Address
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white" data-id="element-13566">
                {paginatedLogs.map(log => <tr key={log.id} className="hover:bg-gray-50 transition-colors" data-id="element-13567">
                    <td className="px-6 py-4 text-sm text-gray-900" title={new Date(log.timestamp).toLocaleString()} data-id="element-13568">
                      {getRelativeTime(log.timestamp)}
                    </td>
                    <td className="px-6 py-4" data-id="element-13569">
                      <div className="flex items-center gap-2" data-id="element-13570">
                        <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 text-xs font-semibold" data-id="element-13571">
                          {log.user.name.split(' ').map(n => n[0]).join('')}
                        </div>
                        <div data-id="element-13572">
                          <p className="text-sm font-medium text-gray-900" data-id="element-13573">
                            {log.user.name}
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-13574">
                            {log.user.role}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-13575">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-13576">
                        {log.action}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600" data-id="element-13577">
                      {log.section}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600 font-mono" data-id="element-13578">
                      {log.objectId}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600 font-mono" data-id="element-13579">
                      {log.ipAddress}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between bg-gray-50" data-id="element-13580">
              <button onClick={() => setCurrentLogPage(Math.max(1, currentLogPage - 1))} disabled={currentLogPage === 1} className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-13581">
                Previous
              </button>
              <span className="text-sm text-gray-600" data-id="element-13582">
                Page {currentLogPage} of {totalPages}
              </span>
              <button onClick={() => setCurrentLogPage(Math.min(totalPages, currentLogPage + 1))} disabled={currentLogPage === totalPages} className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-13583">
                Next
              </button>
            </div>}
        </div>
      </div>
    </div>;
}